export default {
      id: "i-question-usage",
      viewBox: "0 0 38.000000 76.000000",
      url: __webpack_public_path__ + "img/sprite.svg#i-question",
      toString: function () {
        return this.url;
      }
    }